import { useState } from 'react';

const videos = [
  {
    title: '什麼是保單健檢？',
    summary: '3 分鐘了解保單健檢的目的、流程與常見發現，讓您知道為什麼每年都應該檢視一次保單。',
    duration: '3:12',
    img: 'https://readdy.ai/api/search-image?query=insurance%20policy%20review%20professional%20advisor%20explaining%20documents%20whiteboard%20presentation%20warm%20office%20clean%20minimal%20educational&width=600&height=380&seq=vid001&orientation=landscape',
    tag: '保單健檢',
    tagColor: '#D4A373',
  },
  {
    title: '買保險前先問自己的 3 個問題',
    summary: '在決定購買任何保險之前，這 3 個問題能幫助您釐清真正的需求，避免買錯或買多。',
    duration: '2:48',
    img: 'https://readdy.ai/api/search-image?query=person%20thinking%20questions%20decision%20making%20professional%20advisor%20consultation%20warm%20office%20natural%20light%20thoughtful%20calm%20atmosphere&width=600&height=380&seq=vid002&orientation=landscape',
    tag: '保險觀念',
    tagColor: '#5C5470',
  },
  {
    title: '醫療險常見迷思',
    summary: '「有健保就夠了嗎？」「住院才能理賠？」釐清 4 個最常見的醫療保險誤解，讓您的保障更到位。',
    duration: '4:05',
    img: 'https://readdy.ai/api/search-image?query=medical%20insurance%20myths%20misconceptions%20healthcare%20professional%20explaining%20patient%20consultation%20clinic%20warm%20light%20educational&width=600&height=380&seq=vid003&orientation=landscape',
    tag: '醫療保險',
    tagColor: '#FF8C69',
  },
  {
    title: '家庭保障怎麼排優先順序？',
    summary: '預算有限時，家庭保障該從哪裡開始？用清楚的優先順序架構，協助您把錢花在最重要的保障上。',
    duration: '3:30',
    img: 'https://readdy.ai/api/search-image?query=family%20financial%20planning%20priority%20order%20professional%20advisor%20whiteboard%20chart%20family%20protection%20warm%20office%20educational%20minimal&width=600&height=380&seq=vid004&orientation=landscape',
    tag: '家庭保障',
    tagColor: '#5C5470',
  },
];

export default function KnowledgeVideos() {
  const [playingIdx, setPlayingIdx] = useState<number | null>(null);

  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            SHORT VIDEOS
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            60 秒保險小知識
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4 mb-4"></div>
          <p className="text-gray-500 max-w-lg mx-auto" style={{ fontSize: '1.0625rem', lineHeight: '1.7' }}>
            用短影音把保險觀念說清楚，讓您在通勤或休息時也能輕鬆學習
          </p>
        </div>

        {/* Video Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7">
          {videos.map((v, i) => (
            <div
              key={v.title}
              className="bg-[#F8F5F0] rounded-2xl overflow-hidden border border-transparent hover:border-[#D4A373]/30 hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              {/* Thumbnail */}
              <div className="relative h-44 overflow-hidden flex-shrink-0">
                <img
                  src={v.img}
                  alt={v.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-[#5C5470]/40 flex items-center justify-center">
                  <button
                    onClick={() => setPlayingIdx(playingIdx === i ? null : i)}
                    className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 hover:bg-white hover:scale-110 transition-all duration-200 cursor-pointer"
                    aria-label={`播放 ${v.title}`}
                  >
                    <i className="ri-play-fill text-[#5C5470] text-2xl ml-1"></i>
                  </button>
                </div>
                <span
                  className="absolute bottom-3 right-3 bg-black/60 text-white px-2.5 py-1 rounded-lg font-medium"
                  style={{ fontSize: '1rem' }}
                >
                  {v.duration}
                </span>
                <span
                  className="absolute top-3 left-3 text-white px-3 py-1 rounded-full font-medium"
                  style={{ fontSize: '1rem', backgroundColor: v.tagColor }}
                >
                  {v.tag}
                </span>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-1">
                <h3
                  className="font-serif font-bold text-[#5C5470] mb-3"
                  style={{ fontSize: 'clamp(1.125rem, 1.3vw, 1.25rem)', lineHeight: '1.5' }}
                >
                  {v.title}
                </h3>
                <p className="text-gray-600 flex-1 mb-5" style={{ fontSize: '1.0625rem', lineHeight: '1.7' }}>
                  {v.summary}
                </p>

                {playingIdx === i ? (
                  <div className="bg-[#5C5470]/8 rounded-xl p-4 text-center">
                    <i className="ri-video-line text-[#5C5470] text-2xl block mb-2"></i>
                    <p className="text-[#5C5470] font-medium" style={{ fontSize: '1rem' }}>影片即將上線</p>
                    <p className="text-gray-500 mt-1" style={{ fontSize: '1rem' }}>敬請期待</p>
                  </div>
                ) : (
                  <button
                    onClick={() => setPlayingIdx(i)}
                    className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-5 py-2.5 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200 cursor-pointer"
                    style={{ fontSize: '1.0625rem' }}
                  >
                    <i className="ri-play-circle-line"></i>
                    觀看影片
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
